<template>
  <main v-if="!selectedWallet" class="main_inner flex-grow-1 loading" />
  <main v-else>
    <div class="withdrawal_area account_area d-grid">
      <div class="account_wrap">
        <div class="account_wrap-container">
          <h5 class="account_title">
            {{ $t('Bao.withdrawal') }}
          </h5>
          <div class="withdrawal_info d-grid">
            <form class="wallet_pay_from d-grid mb-0" action="">
              <div class="wallet_pay_block d-grid">
                <div class="withdrawal_one d-grid">
                  <h5 class="wallet_pay_title mb-0">
                    1. {{ $t('Bao.select_wallet') }}
                  </h5>
                  <ul class="wallet_pay_aisle d-flex list-unstyled mb-0">
                    <li
                      v-for="(item, itemKey) in wallets"
                      :key="itemKey"
                    >
                      <button
                        :class="'btn btn_aisle '+ (item.key==selectedWallet.key?'active':'')"
                        type="button"
                        @click="selectWallet(item)"
                      >
                        <div class="mb-1">
                          {{ item.name }}
                        </div>
                        <div class="mb-0">
                          {{ item.gold }}
                        </div>
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="withdrawal_two d-grid">
                  <h5 class="wallet_pay_title mb-0">
                    2. {{ $t('Bao.select_bankcard_or_ewallet') }}
                    <span style="color:#ff4d4d">{{ $t('Bao.select_bankcard_or_ewallet_tip') }}</span>
                  </h5>
                  <div class="bank_area">
                    <ul class="bank_pay_list d-grid list-unstyled mb-0">
                      <li
                        v-for="(bank, key) in myBanks"
                        :key="key"
                      >
                        <div class="position-relative">
                          <a
                            :class="'d-flex flex-column btn btn_bank '+ (bank.id==postForm.member_bank_id?'active':'')"
                            @click="selectBank(bank.id)"
                          >
                            <h5 class="bank_pay_name mb-0">{{ bank.bank_name }}</h5>
                            <h6 class="bank_pay_num mb-0">
                              ({{ $t('Bao.tail_number') }} {{ bank.card_number.substr(bank.card_number.length - 3) }})
                            </h6>
                          </a>
                        </div>
                      </li>
                      <li>
                        <router-link
                          class="d-flex flex-column btn btn_bank add"
                          to="/bank"
                        >
                          <h5 class="bank_pay_name mb-0">
                            <b>
                              {{ $t('Bao.bind_bank_card') }}
                            </b>
                          </h5>
                        </router-link>
                      </li>
                      <li v-if="selectedWallet.key==='commission'">
                        <a
                          :class="'d-flex flex-column btn btn_bank '+ (postForm.member_bank_id=='commissionToMain'?'active':'')"
                          :style="'border-color:'+ (postForm.member_bank_id=='commissionToMain'?'#9aeeaa':'#ffffff')"
                          @click="selectBank('commissionToMain')"
                        >
                          <h5 class="bank_pay_name mb-0">
                            <b>
                              {{ $t('Bao.commission_to_main') }}
                            </b>
                          </h5>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="withdrawal_three d-grid">
                  <div class="wallet_pay_top d-flex align-items-center">
                    <h5 class="wallet_pay_title mb-0">
                      3. {{ $t('Bao.please_input_withdrawal_amount') }}
                    </h5>
                  </div>
                  <div class="wallet_pay_key">
                    <!--                  <input-->
                    <!--                    v-model="postForm.amount"-->
                    <!--                    v-validate="'required|integer|min_value:'+selectedWallet['amount_limit'].min+'|max_value:'+selectedWallet['amount_limit'].max"-->
                    <!--                    :data-vv-as="$t('Bao.amount')"-->
                    <!--                    name="amount"-->
                    <!--                    type="number"-->
                    <!--                    class="wallet_pay_ipt w-100"-->
                    <!--                    pattern="[0-9]*"-->
                    <!--                    step="1"-->
                    <!--                    required-->
                    <!--                    :placeholder="$t('Bao.please_input_withdrawal_amount')"-->
                    <!--                  >-->

                    <input

                      v-model="postForm.amount"
                      v-validate="'required|integer|min_value:' + selectedWallet['amount_limit'].min + '|max_value:' + selectedWallet['amount_limit'].max"
                      :data-vv-as="$t('Bao.amount')"
                      name="amount"
                      type="number"
                      :class="['wallet_pay_ipt','w-100','is_true',{ 'text-black': amountChange }]"
                      pattern="[0-9]*"
                      step="1"
                      required
                      :placeholder="$t('Bao.please_input_withdrawal_amount')"
                    >
                    <small v-if="errors.has('amount')" class="help-block">
                      {{ errors.first("amount") }}
                    </small>
                    <!--                  <small v-if="errors.has('amount')" class="false_status">-->
                    <!--                    {{ errors.first('amount') }}-->
                    <!--                  </small>-->
                    <!-- 需滿足流水量提示 (選擇主錢包出金時才顯示這段提示) -->
                    <p v-if="postForm.wallet==='common'" class="wallet_pay_tips mt-5 mb-0">
                      <small class="personal_price_tips">{{ $t('Bao.diff_performance_withdrawal', [goldInfo.withdrawal_limit]) }}</small>
                    </p>
                    <p class="wallet_pay_tips mt-5 mb-0">
                      {{ $t('Bao.available_withdrawal_amount') }}
                      {{ selectedWallet['amount_limit'].max }}
                      <span class="pull-right">{{ $store.getters.brand.currency }}</span>
                      <!-- <span v-if="$store.getters.brand.currency == 'VND'" class="pull-right">{{ $t("Bao.vnd_info") }}</span>
                      <span v-else class="pull-right">{{ $t("Bao.cny") }}</span> -->
                    </p>
                    <br v-if="postForm.member_bank_id!='commissionToMain'">
                    <input
                      v-if="postForm.member_bank_id!='commissionToMain'"
                      v-model="postForm.withdrawal_pass"
                      v-validate="'required'"
                      name="withdrawal_pass"
                      required
                      :data-vv-as="$t('Bao.withdrawal_password')"
                      pattern="[0-9]*"
                      class="wallet_pay_ipt w-100 is_fals"
                      type="password"
                      :placeholder="$t('Bao.withdrawal_password')"
                    >
                    <small
                      v-if="errors.has('withdrawal_pass') && postForm.member_bank_id!='commissionToMain'"
                      class="false_status"
                    >
                      {{ errors.first('withdrawal_pass') }}
                    </small>
                  </div>
                  <button
                    class="btn btn_withdraw"
                    type="button"
                    @click="setAllAmount()"
                  >
                    {{ $t('Bao.withdrawal_all') }}
                  </button>
                  <div v-if="postForm.member_bank_id!='commissionToMain'">
                    <button
                      class="btn btn_confirm"
                      type="button"
                      :disabled="actionLoading"
                      @click="preCheck()"
                    >
                      {{ $t('Bao.commit') }}
                      <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
                    </button>
                  </div>
                  <div v-else>
                    <button
                      class="btn btn_confirm"
                      type="button"
                      @click="handleCommissionToMain()"
                    >
                      {{ $t('Bao.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div class="d-md-block">
              <ul class="bonus_offer_list d-grid list-unstyled mb-0 wallet_list">
                <li v-for="(item, key) in eventList" :key="key">
                  <a
                    class="card bonus_offer_card border-0 p-0"
                  >
                    <picture class="picture" @click="$router.push('/event/' + item.id)">
                      <source
                        media="(min-width: 992px)"
                        :srcset="item.image_small"
                      >

                      <!-- 手機版圖片 -->
                      <img
                        class="img"
                        :src="item.image_mobile"
                        alt=""
                      >
                    </picture>
                    <div class="inverted-border-radius">
                      <div class="info">
                        <div class="text">
                          <p>{{ item.start_at | dateFormat }}<br>~</p>
                          <p>{{ item.end_at | dateFormat }}</p>
                        </div>

                        <div v-if="item.status === 2" class="btn btn_over">
                          <p class="">{{ item.status_text }}</p>
                        </div>
                        <div v-if="item.status === 3 || item.status === 5" class="btn" @click="clickAction(item)">
                          <p class="">{{ item.status_text }}</p>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal_check"
      ref="modal_check"
      modal-class="modal_bet_detail"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md modal_wallet"
      header-class="modal-header justify-content-start align-items-center border-bottom-0"
      body-class="text-center"
      footer-class="modal-footer justify-content-center border-top-0"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t('Bao.withdrawal_detail') }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" @click="hideWithdrawalCheck()">
          <i class="icon-clear" />
        </button>
      </template>
      <h6 class="mb-0">
        <div class="modal_bet_detail_data">
          <div class="d-flex justify-content-center">
            <div class="modal_bet_detail_data_row d-flex">
              <div class="mr-auto">
                {{ $t('Bao.card_number') }}
              </div>
              <div class="number text-left">
                {{ getBandCardName() }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <div class="modal_bet_detail_data_row d-flex">
              <div class="mr-auto">
                {{ $t('Bao.withdrawal_amount') }}
              </div>
              <div class="number text-left">
                {{ $options.filters['numberFormat'](withdrawalCheck.amount) }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <div class="modal_bet_detail_data_row d-flex">
              <div class="mr-auto">
                {{ $t('Bao.withdrawal_fee') }}
              </div>
              <div class="number text-left">
                {{ $options.filters['numberFormat'](withdrawalCheck.withdrawal_fee) }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <div class="modal_bet_detail_data_row d-flex">
              <div class="mr-auto">
                {{ $t('Bao.withdrawal_real_amount') }}
              </div>
              <div class="number text-left">
                {{ $options.filters['numberFormat'](withdrawalCheck.actual_amount) }}
              </div>
            </div>
          </div>
        </div>
      </h6>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn modal_btns d-flex justify-content-center w-100">
          <button type="button" class="btn btn_transfer text-white" :disabled="actionDoLoading" @click="doWithdrawal()">
            {{ $t('Bao.confirm_withdrawal') }} <i v-show="actionDoLoading" class="fa fa-spinner fa-pulse fa-fw" />
          </button>
          <button type="button" class="btn btn_immediately" @click="hideWithdrawalCheck()">
            {{ $t('Bao.cancel') }}
          </button>
        </div>
      </template>
    </b-modal>
  </main>
</template>

<script>
import { withdrawalCheck, withdrawalPayment, withdrawalWallet, commissionToMain, goldInfo } from '@/api/payment'
import { getMyBanks } from '@/api/bank'
import { showNotice, setErrorMessage } from '@/utils/tool'
import { getEvent, joinEvent, receive } from '@/api/event'

export default {
  name: 'Withdrawal',
  components: {},
  data() {
    return {
      actionLoading: false,
      actionDoLoading: false,
      wallets: null,
      withdrawalCheck: {
        'amount': null,
        'withdrawal_fee': null,
        'actual_amount': null,
        'status': null,
        'require_performance': null,
        'performance_need': null,
        'current_performance': null
      },
      selectedWallet: null,
      postForm: {
        wallet: 'common',
        amount: '',
        withdrawal_info: '',
        withdrawal_pass: null,
        member_bank_id: null
      },
      myBanks: [],
      amountChange: false,
      goldInfo: false,
      eventList: []
    }
  },
  computed: {
    title() {
      return null
    }
  },
  created() {
    const dict = {
      custom: {
        amount: {
          max_value: this.$t('Bao.withdrawal_limit_tips')
        }
      }
    }

    this.$validator.localize('zh', dict)

    withdrawalWallet().then((response) => {
      this.wallets = response.data.data
      this.selectWallet(this.wallets[0])

      getMyBanks().then((response) => {
        this.myBanks = response.data.data
        this.selectBank(this.myBanks[0].id)
      }).catch(() => {
        console.log('Cannot get bank list')
      })
    }).catch((error) => {
      const result = error.response.data
      showNotice(result.msg)

      if (result.data.type === 'info') {
        this.$router.push({ path: '/user/account' }).catch(() => {
        })
      } else if (result.data.type === 'bank_card') {
        this.$router.push({ path: '/bank' }).catch(() => {
        })
      }
    })
    this.getGoldInfo()

    this.queryEvent()
  },
  methods: {
    queryEvent() {
      getEvent({
        'is_show_in_withdrawal': 1,
        'page': 1,
        'page_size': 50
      }).then((response) => {
        this.eventList = response.data.data.list
      })
    },
    clickAction(item) {
      console.log(item)
      if (item.status === 3) {
        this.actionLoading = item.id
        joinEvent(item.id)
          .then((response) => {
            showNotice(response.data.msg)
            this.queryEvent()
          })
          .catch((error) => {
            showNotice(error.response.data.msg)
          })
          .finally((e) => {
            this.actionLoading = false
          })
      } else if (item.status === 5) {
        this.actionLoading = item.id
        receive(item.event_member_id)
          .then((response) => {
            showNotice(response.data.msg)
            this.queryEvent()
          })
          .catch((error) => {
            showNotice(error.response.data.msg)
          })
          .finally((e) => {
            this.actionLoading = false
          })
      }
    },
    selectWallet(selectedValue) {
      this.selectedWallet = selectedValue
      this.postForm.wallet = selectedValue.key
      this.postForm.amount = selectedValue['amount_limit'].min
    },
    selectBank(selectedValue) {
      this.postForm.member_bank_id = selectedValue
    },
    getBandCardName() {
      for (const i in this.myBanks) {
        if (this.myBanks[i].id === this.postForm.member_bank_id) return this.myBanks[i].card_number
      }
    },
    setAllAmount() {
      this.postForm.amount = this.selectedWallet['amount_limit'].max
    },
    preCheck(e) {
      // 當提款所需流水量大於 0 時，在 vee-validate 檢查前就先跳出 modal 提示
      // wallet type (common, commission)
      if (this.postForm.wallet === 'common' && this.goldInfo.withdrawal_limit > 0) {
        showNotice(this.$t('Bao.lack_diff_performance_withdrawal_1') + '\xa0\xa0\xa0\xa0' + this.goldInfo.withdrawal_limit + '\xa0\xa0\xa0\xa0' + this.$t('Bao.lack_diff_performance_withdrawal_2'))
        return false
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (this.postForm.amount <= 0 || isNaN(this.postForm.amount)) {
            showNotice(this.$t('Bao.withdrawal_amount') + ' ' + this.$t('Bao.need_over_zero'))
            return false
          }
          this.actionLoading = true
          withdrawalCheck({ amount: this.postForm.amount, wallet: this.selectedWallet.key }).then((response) => {
            if (response.data.data.status === 'deny') {
              showNotice(response.data.data.message)
            } else {
              this.withdrawalCheck = response.data.data
              this.showWithdrawalCheck()
            }
          }).catch(() => {
            console.log('Cannot get wallet type')
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    },
    showWithdrawalCheck() {
      this.$bvModal.show('modal_check')
    },
    hideWithdrawalCheck() {
      this.$bvModal.hide('modal_check')
    },
    doWithdrawal() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          const self = this
          if (this.postForm.amount <= 0 || isNaN(this.postForm.amount)) {
            showNotice(this.$t('Bao.withdrawal_amount') + ' ' + this.$t('Bao.need_over_zero'))
            this.hideWithdrawalCheck()
            return false
          }
          this.actionDoLoading = true
          withdrawalPayment(this.postForm).then((response) => {
            showNotice(response.data.msg, function() {
              self.$router.push({ path: '/payment/withdrawal-record' })
            })
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          }).finally(() => {
            this.hideWithdrawalCheck()
            this.actionDoLoading = false
          })
        }
      })
    },
    handleCommissionToMain() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          const self = this
          if (this.postForm.amount <= 0 || isNaN(this.postForm.amount)) {
            showNotice(this.$t('Bao.amount') + ' ' + this.$t('Bao.need_over_zero'))
            return false
          }
          commissionToMain({ amount: this.postForm.amount }).then((response) => {
            showNotice(this.$t('Bao.transfer_finish'), function() {
              self.$router.push({ path: '/transaction' })
            })
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          })
        }
      })
    },
    getGoldInfo() {
      goldInfo().then(response => {
        this.goldInfo = response.data.data
      })
    }
  }
}
</script>

<style scoped>
    .modal_bet_detail .modal_bet_detail_data > li:before {
        min-width: 150px;
        -moz-text-align-last: justify;
        text-align-last: left;
    }

    .btn_bank.active {
      background: linear-gradient(90deg, #ffb500 0%, #ff5000 100%);
      border: transparent;
      color: #fff;
    }
    .bank_area .btn_bank.active .bank_pay_num {
      color: #fff;
    }
    @media only screen and (max-width: 991px) {
      .bank_area .btn_bank.active .bank_pay_name {
        color: #fff;
      }
    }
    .modal_bet_detail_data_row {
      width: 200px;
      line-height: 30px;
    }
    .modal_bet_detail_data_row .number {
      width: 40px;
    }
</style>
